import { render } from "./UnderRow.vue?vue&type=template&id=3615a75a&scoped=true"
import script from "./UnderRow.vue?vue&type=script&lang=js"
export * from "./UnderRow.vue?vue&type=script&lang=js"

import "./UnderRow.vue?vue&type=style&index=0&id=3615a75a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3615a75a"]])

export default __exports__